import { lazy, Suspense } from "react";
import { GlobalLoading } from "../Utils";

const ProgramCoordinatorHome = lazy(() =>
  import("../Components/ProfilesType/ProgramCoordinator/ProgramCoordinatorHome/ProgramCoordinatorHome")
);
const Quizzes = lazy(() =>
  import("../Components/ProfilesType/ProgramCoordinator/Quizzes/Quizzes")
);
const SeriesDetail = lazy(() =>
  import("../Components/ProfilesType/ProgramCoordinator/Quizzes/SeriesDetail")
);
const QuizDetail = lazy(() =>
  import("../Components/ProfilesType/ProgramCoordinator/Quizzes/QuizDetail")
);

export const programCoordinatorRoutes = [
  {
    index: true,
    element: (
      <Suspense fallback={<GlobalLoading />}>
        <ProgramCoordinatorHome />
      </Suspense>
    ),
  },
  {
    path: "quizzes",
    element: (
      <Suspense fallback={<GlobalLoading />}>
        <Quizzes />
      </Suspense>
    ),
  },
  {
    path: "quizzes/:seriesId",
    element: (
      <Suspense fallback={<GlobalLoading />}>
        <SeriesDetail />
      </Suspense>
    ),
  },
  {
    path: "quizzes/:seriesId/:quizId",
    element: (
      <Suspense fallback={<GlobalLoading />}>
        <QuizDetail />
      </Suspense>
    ),
  },
];
